const heroKeywords = ['相关事件', '类似案例', '同类盘点', '横向对比'];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-ink pt-16">
      {/* big main visual as backdrop */}
      <div className="pointer-events-none absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20editorial%20backdrop%20with%20flowing%20warm%20gradient%20waves%20in%20deep%20terracotta%20ember%20orange%20rust%20caramel%20and%20near%20black%20coffee%20tones%2C%20soft%20studio%20lighting%2C%20cinematic%20depth%2C%20silky%20organic%20shapes%20with%20fine%20grain%2C%20minimal%20premium%20aesthetic%2C%20no%20text%20no%20objects&width=1600&height=900&seq=meihei-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/30 to-cream" />
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-16 pt-16 text-center md:px-6 md:pb-24 md:pt-24">
        <span className="eyebrow reveal text-honey-300">
          <i className="ri-fire-line" aria-hidden="true"></i>
          媚黑大赛 · 话题全景盘点站
          <i className="ri-fire-line" aria-hidden="true"></i>
        </span>

        <h1 className="display reveal mt-6 text-4xl leading-tight text-paper md:text-6xl">
          一个热搜词背后，
          <br className="md:hidden" />
          藏着一整套吃瓜链条
        </h1>

        <p className="reveal mt-6 max-w-2xl text-[15px] leading-relaxed text-cream/75 md:text-base">
          除了媚黑大赛本身，还有哪些类似事件与相关案例值得围观？本页把同类话题拉进同一张桌，
          <br className="hidden md:block" />
          横向对比起因、经过与舆论反应，帮你建立更完整的吃瓜视角。
        </p>

        <div className="reveal mt-7 flex flex-wrap items-center justify-center gap-2">
          {heroKeywords.map((k, i) => (
            <span
              key={k}
              className="inline-flex items-center gap-1.5 rounded-full border border-paper/20 bg-paper/10 px-3 py-1.5 text-xs font-medium text-paper/85"
            >
              {i > 0 && <i className="ri-add-line text-honey-300/70" aria-hidden="true"></i>}
              {k}
            </span>
          ))}
        </div>

        <div className="reveal mt-9 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#pandian"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-ember-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-ember-400 sm:w-auto"
          >
            看同类盘点榜单
            <i className="ri-arrow-down-line" aria-hidden="true"></i>
          </a>
          <a
            href="#duibi"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-paper/25 bg-paper/5 px-6 py-3 text-sm font-semibold text-paper transition-colors hover:bg-paper/15 sm:w-auto"
          >
            直接横向对比
          </a>
        </div>

        <dl className="reveal mt-12 grid w-full max-w-3xl grid-cols-3 divide-x divide-paper/15 rounded-2xl border border-paper/10 bg-paper/5 backdrop-blur-sm">
          {[
            { v: '6+', l: '同类话题盘点' },
            { v: '5 段', l: '传播脉络还原' },
            { v: '3 维', l: '案例横向对比' },
          ].map((s) => (
            <div key={s.l} className="flex flex-col items-center gap-1 px-2 py-4">
              <dt className="order-2 text-[11px] text-cream/60 md:text-xs">{s.l}</dt>
              <dd className="display order-1 text-xl text-honey-300 md:text-2xl">{s.v}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}